import React, { useContext, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { DataContext } from '../contexts/DataContext';

const PaymentAdvanceStatusCard = () => {
  const { paymentAdvances } = useContext(DataContext); // Assuming paymentAdvances data is available in DataContext
  const [approvedCount, setApprovedCount] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);

  useEffect(() => {
    // Compute counts based on payment advances data from DataContext
    const approvedAdvances = paymentAdvances.filter(advance => advance.status === "Approved").length;
    const pendingAdvances = paymentAdvances.filter(advance => advance.status === "Pending").length;
    
    setApprovedCount(approvedAdvances);
    setPendingCount(pendingAdvances);
  }, [paymentAdvances]); // Recompute when paymentAdvances data changes

  return (
    <div className="bg-white shadow rounded-lg p-6 w-full max-w-lg h-custom-card-small">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold text-gray-800 flex items-center">
          <FontAwesomeIcon icon={faCheckCircle} className="text-green-600 mr-3" />
          Payment Advance Status
        </h2>
        <a href="/payment-advances-status" className="text-md text-green-600 hover:text-green-800 transition duration-300">
          View all
        </a>
      </div>
      <div className="grid grid-cols-2 divide-x divide-gray-200 text-center">
        <div className="px-4 py-2">
          <FontAwesomeIcon icon={faCheckCircle} className="text-green-600 text-3xl mb-2" />
          <p className="text-md text-gray-600">Approved</p>
          <p className="text-2xl font-semibold text-gray-800">{approvedCount}</p>
        </div>
        <div className="px-4 py-2">
          <FontAwesomeIcon icon={faTimesCircle} className="text-red-600 text-3xl mb-2" />
          <p className="text-md text-gray-600">Pending</p>
          <p className="text-2xl font-semibold text-gray-800">{pendingCount}</p>
        </div>
      </div>
    </div>
  );
};

export default PaymentAdvanceStatusCard;
